import { BillingModel } from '@/modules/billing/entities/billing.enums';
import { FeeForLifeEligibility } from '@/modules/billing/entities/billing.interfaces';
import HttpClientAdapter from '@/shared/services/httpClientAdapter';

const pendingRequests = new Map<string, Promise<{ model: BillingModel }>>();

export class BillingService extends HttpClientAdapter {
  constructor() {
    super('NEGOTIATION');
  }

  getBillingModel(companyId: string): Promise<{ model: BillingModel }> {
    if (pendingRequests.has(companyId)) {
      return pendingRequests.get(companyId)!;
    }

    const requestPromise = this.fetchBillingModel(companyId);
    pendingRequests.set(companyId, requestPromise);

    return requestPromise;
  }

  private async fetchBillingModel(companyId: string): Promise<{ model: BillingModel }> {
    try {
      const { isEligible } = await this.get<FeeForLifeEligibility>(
        `/companies/${companyId}/fee-for-life-eligibility`
      );
      return {
        model: isEligible ? BillingModel.FEE_FOR_LIFE : BillingModel.FEE_FOR_SERVICE
      };
    } finally {
      pendingRequests.delete(companyId);
    }
  }
}
